// Returns the number of whole days until 25 December in NZ (Pacific/Auckland)
// local time. Returns null once Christmas has passed for the year (26 Dec
// onwards, NZ time) so callers can hide holiday-only UI cleanly.

function nowInNZParts() {
  // Use Intl to derive current Y/M/D in Pacific/Auckland regardless of
  // the visitor's local timezone.
  const parts = new Intl.DateTimeFormat("en-NZ", {
    timeZone: "Pacific/Auckland",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(new Date());
  const get = (t) => Number(parts.find((p) => p.type === t)?.value);
  return { year: get("year"), month: get("month"), day: get("day") };
}

export function daysUntilChristmas() {
  const { year, month, day } = nowInNZParts();
  // Christmas of current year — if we're already past 25 Dec, roll to next year.
  const passedThisYear = month === 12 && day > 25;
  const targetYear = passedThisYear ? year + 1 : year;

  // Both dates in UTC-of-NZ-midnight to compute day diff cleanly.
  const nowUTC = Date.UTC(year, month - 1, day);
  const xmasUTC = Date.UTC(targetYear, 11, 25);
  const diffDays = Math.round((xmasUTC - nowUTC) / (1000 * 60 * 60 * 24));

  return { days: diffDays, passed: passedThisYear };
}

// True while the Christmas drop should still be promoted (up to and including
// 25 Dec NZ time). Becomes false on 26 Dec NZ.
export function isChristmasSeasonActive() {
  const { passed } = daysUntilChristmas();
  return !passed;
}
